import React from 'react';

export default function TextDisplay({
  textToDisplay,
  containerStyle = {},
  textStyle = {},
  isVisible = true
}) {
  let content;
  if (Array.isArray(textToDisplay)) {
    content = textToDisplay.map((ele) => {
      return (
        <p css={textStyle} key={ele}>
          {ele}
        </p>
      );
    });
  } else {
    content = <p css={textStyle}>{textToDisplay}</p>;
  }
  return isVisible && <div css={containerStyle}>{content}</div>;
}
